import {
  EXTRAS_BATCH_DELETE_REQUEST,
  EXTRAS_BATCH_DELETE_SUCCESS,
  EXTRAS_BATCH_DELETE_FAILURE,
  EXTRAS_FETCH_MANY_REQUEST,
  EXTRAS_FETCH_MANY_SUCCESS,
  EXTRAS_FETCH_MANY_FAILURE,
  EXTRAS_FETCH_REQUEST,
  EXTRAS_FETCH_SUCCESS,
  EXTRAS_FETCH_FAILURE,
  EXTRAS_SAVE_REQUEST,
  EXTRAS_SAVE_SUCCESS,
  EXTRAS_SAVE_FAILURE,

  EMPTY_EXTRAS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(EXTRAS_BATCH_DELETE_REQUEST)
    return window.axios.post('/extras', { _method: 'DELETE', ids }).then(response => {
      commit(EXTRAS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(EXTRAS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1 }) {
    commit(EXTRAS_FETCH_MANY_REQUEST)
    return window.axios.get('/extras', { params: { query, page } }).then(response => {
      commit(EXTRAS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(EXTRAS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(EXTRAS_FETCH_REQUEST)
    return window.axios.get(`/extras/${id}`).then(response => {
      commit(EXTRAS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(EXTRAS_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, extra) {
    const path = extra.id ? `/extras/${extra.id}` : '/extras'
    const method = extra.id ? 'put' : 'post'

    commit(EXTRAS_SAVE_REQUEST)
    return window.axios[method](path, extra).then(response => {
      commit(EXTRAS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(EXTRAS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(EXTRAS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_EXTRAS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
